import React from "react";

import { BECOME_A_BATMAID_LINK } from "@config/links";
import { HOMEPAGE_V2 } from "@config/testIds/app";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Button } from "@components/General/Button";

import { useTranslate } from "@hooks/useTranslate";
import { useTelemetry } from "@hooks/useTelemetry";

import * as Styled from "./CallToAction.styled";

export const CallToAction: React.FC<
  Pick<React.ComponentPropsWithoutRef<"div">, "className"> & {
    language: AVAILABLE_LANGS;
  }
> = ({ className, language }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");
  const { sendEvent } = useTelemetry();

  return (
    <Styled.Root className={className}>
      <Styled.TextWrapper>
        <Styled.Title>{translate("become_a_batmaid_heading")}</Styled.Title>
        <Styled.Subtitle>
          {translate("become_a_batmaid_description")}
        </Styled.Subtitle>
      </Styled.TextWrapper>
      <Styled.CallToActionWrapper>
        <a href={`/${language}${BECOME_A_BATMAID_LINK}`}>
          <Button
            testId={HOMEPAGE_V2.BECOME_BATMAID_BTN}
            size="large"
            variantStyle="fill"
            colorType="blue"
            onClick={() => {
              sendEvent("become_batmaid_click", {
                buttonLabel: "become_a_batmaid_button",
                context: {
                  source: "section",
                },
              });
            }}
          >
            {translate("become_a_batmaid_button")}
          </Button>
        </a>
      </Styled.CallToActionWrapper>
    </Styled.Root>
  );
};
